///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2002-2025, Open Design Alliance (the "Alliance").
// All rights reserved.
//
// This software and its documentation and related materials are owned by
// the Alliance. The software may only be incorporated into application
// programs owned by members of the Alliance, subject to a signed
// Membership Agreement and Supplemental Software License Agreement with the
// Alliance. The structure and organization of this software are the valuable
// trade secrets of the Alliance and its suppliers. The software is also
// protected by copyright law and international treaty provisions. Application
// programs incorporating this software must include the following statement
// with their copyright notices:
//
//   This application incorporates Open Design Alliance software pursuant to a
//   license agreement with Open Design Alliance.
//   Open Design Alliance Copyright (C) 2002-2025 by Open Design Alliance.
//   All rights reserved.
//
// By use of this software, its documentation or related materials, you
// acknowledge and accept the above terms.
///////////////////////////////////////////////////////////////////////////////

import type { FileSource, ILoader, LoadParams } from "./ILoader";

export class Loader implements ILoader {
  public name = "";
  public abortController: AbortController = new AbortController();

  dispose(): void {
    this.abortController.abort();
    this.abortController = undefined;
  }

  isSupport(file: FileSource, format?: string): boolean {
    return false;
  }

  load(file: FileSource, format?: string, params?: LoadParams): Promise<this> {
    return Promise.resolve(this);
  }

  cancel(): void {
    this.abortController.abort();
  }

  yield(): Promise<void> {
    return new Promise((resolve) => {
      setTimeout(resolve, 0);
    });
  }

  extractFileName(file: FileSource): string {
    const regex = /[^/\\?#:]+(?=\?|#|$)/;

    if (typeof file === "string") return (file.match(regex) || [])[0];
    else if (file instanceof globalThis.File) return (file.name.match(regex) || [])[0];

    return undefined;
  }
}
